import { authRouteList } from './login/route'

export const AuthRouteList = [...authRouteList]
